import { render, staticRenderFns } from "./CodePacket.vue?vue&type=template&id=1bee44e7&scoped=true"
import script from "./CodePacket.vue?vue&type=script&lang=js"
export * from "./CodePacket.vue?vue&type=script&lang=js"
import style0 from "./CodePacket.vue?vue&type=style&index=0&id=1bee44e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bee44e7",
  null
  
)

export default component.exports